export interface ThirdPartyPayload {
  link: string;
  width: string;
  height: string;
}

export type ThirdPartyListener = (payload: ThirdPartyPayload) => void;

export const ThirdPartyModal = (() => {
  let _listener: ThirdPartyListener;

  const setRootCmp = (listener: ThirdPartyListener) => {
    _listener = listener;
  };
  const show = (payload: ThirdPartyPayload) => {
    _listener(payload);
  };
  return {
    setRootCmp,
    show,
  };
})();
